import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c0b09e10&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=c0b09e10&lang=less&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=c0b09e10&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0b09e10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0b09e10')) {
      api.createRecord('c0b09e10', component.options)
    } else {
      api.reload('c0b09e10', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c0b09e10&scoped=true", function () {
      api.rerender('c0b09e10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/homeNew/index.vue"
export default component.exports